import React from 'react';

const FEATURES: { icon: string; title: string; description: string }[] = [
    { icon: '📸', title: 'Scan Receipts', description: 'Photograph or upload receipts and let AI extract every detail automatically.' },
    { icon: '📊', title: 'Spending Reports', description: 'Monthly and historical reports broken down by merchant, category and product.' },
    { icon: '🗺️', title: 'Heat Map', description: 'Visualise where you spend across merchants on an interactive map.' },
    { icon: '📂', title: 'Categories', description: 'Organise expenses into categories and track budgets over time.' },
    { icon: '🏪', title: 'Merchants & Brands', description: 'Full merchant and brand directory with linked receipts and spend totals.' },
    { icon: '👥', title: 'Friends', description: 'Add friends and share spending insights with people you trust.' },
    { icon: '💬', title: 'Chat', description: 'Message friends directly or reach sConscious support from within the app.' },
    { icon: '🔔', title: 'Push Notifications', description: 'Get notified when receipt analysis is complete or a friend sends you a message.' },
    { icon: '📱', title: 'Installable PWA', description: 'Install sConscious on any device — works offline and feels like a native app.' },
    { icon: '💱', title: 'Multi-Currency', description: 'Track expenses in any currency with automatic symbol display.' },
    { icon: '🖼️', title: 'Profile Photo', description: 'Personalise your account with a profile photo, uploaded straight from your camera.' },
    { icon: '💳', title: 'Fidelity Cards', description: 'Photograph and store all your loyalty cards in one place — tap to view full screen.' },
];

export default function Features() {
    return (
        <div style={{ maxWidth: 640, margin: '0 auto', padding: '18px 14px 40px', textAlign: 'left' }}>
            <div style={{ fontWeight: 800, fontSize: '1.15rem', marginBottom: 18, letterSpacing: -0.3 }}>
                Features
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {FEATURES.map(f => (
                    <div
                        key={f.title}
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 14,
                            background: 'rgba(0,0,0,0.07)',
                            borderRadius: 14,
                            padding: '12px 16px',
                        }}
                    >
                        <span style={{ fontSize: '1.5rem', lineHeight: 1, flexShrink: 0, marginTop: 2 }}>{f.icon}</span>
                        <div>
                            <div style={{ fontWeight: 700, fontSize: '0.92em', marginBottom: 2 }}>{f.title}</div>
                            <div style={{ fontSize: '0.82em', opacity: 0.65, lineHeight: 1.45 }}>{f.description}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
